import React from "react";
import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage";
import Layout from "./pages/Layout";
import { RouterProvider } from "react-router-dom";
import Accounts from "./pages/Accounts";
import PathwayPage from "./pages/PathwayPage";

const RouterIndex = () => {
  // const dispatch = useInteractionTreeAppDispatch();
  // const params = useParams();

  const router = createBrowserRouter([
    {
      element: <Layout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: <Accounts />,
        },
        {
          path: "/accounts",
          element: <Accounts />,
        },
        // s = set, p = parent. Use as delimiters for dynamic path
        // i.e.
        // s1p1 (set 1, parent 1)
        // s1p23 (set 1, parent 23)
        // s1 (set 1, no parent but set is required)
        // s1p1/s1p23/s1 (form a path that can be used to assist breadcrumbs as well)
        {
          path: "/contents/:interactionPath",
          element: <PathwayPage />,
          // a loader would be preferred but we cant access params here, we we'll call fetchAndProcessInteractions in the component itself
          // loader: async ()=> {
          //   console.log(params.interactionPath)
          //   // dispatch(fetchAndProcessInteractions(1, false, false, true));

          // }
        },
        {
          path: "/reports/:interactionPath",
          element: <PathwayPage />,
        },
        {
          path: "/patients/:interactionPath",
          element: <PathwayPage />,
        },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
};

export default RouterIndex;
